var _g, _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362 322",
    role: "img",
    filter: "url(#grayscale)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "rest-in-peace") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M143 305H63.5s-46.233-15.148-58.57-18.218c-12.336-3.07-2.167-22.8 37.81-18.046C53.24 269.984 142 306 143 305z",
    opacity: 0.299
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M47.5 253H51l5-3-4 1-3.443-1.226L44 248.098v-24.596c0-8.566 2.307-16.714 6.5-23.502l3.084.915 1.005 5.228L56.5 212l.502-5.857v-6.836l-.356-5.884C64.804 184.076 75.12 179 88.5 179c4.658 0 9.148.72 13.368 2.046l.003-.002.202.072c.792.253 1.572.532 2.344.827L123 189l-9.41-2.25c11.717 8.015 19.41 21.483 19.41 36.752V305H63.5L50 300.5l-4.5-45 2-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M60 229.07C60 204.733 79.923 185 104.5 185c24.576 0 44.5 19.732 44.5 44.07L143.133 305h-79.78L60 229.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    stroke: "#979797",
    strokeWidth: 4,
    d: "M68 229.524L70.46 294h68.26l3.28-64.488C141.973 209.347 125.422 193 105 193c-20.427 0-36.98 16.354-37 36.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M45.5 255.5l.812-2.812L49 250.5l3 1 4-1.5-5 3h-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M52 251.5l-1 1.5h-3.5l1.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M114.56 266.59c1.018.233 1.66 1.287 1.435 2.343-.225 1.056-1.241 1.723-2.258 1.49l-14.947-1.966a1.906 1.906 0 0 1-1.525-1.177 2.037 2.037 0 0 1 .238-1.956 1.863 1.863 0 0 1 1.76-.746l14.947 1.965.175.023.176.023zm5.73-3.19l-5.607-.737a5.211 5.211 0 0 0-4.323 1.403l-6.773-.891a5.324 5.324 0 0 0-3.85-2.477l-5.606-.737c-3.175-.417-5.914 1.787-6.315 5.082-.402 3.297 1.72 6.14 4.895 6.556l5.606.738a5.215 5.215 0 0 0 4.323-1.403l6.773.89a5.322 5.322 0 0 0 3.85 2.478l5.606.737c3.175.417 5.914-1.785 6.315-5.082.403-3.297-1.72-6.139-4.895-6.557zm.472-3.88c5.233.69 8.822 5.495 8.16 10.928-.664 5.433-5.293 9.159-10.526 8.47l-5.606-.737c-2.992-.393-5.605-2.315-7-4.862-1.963 2.105-4.955 3.29-7.946 2.897l-5.606-.737c-5.233-.688-8.822-5.494-8.16-10.927.664-5.433 5.293-9.159 10.527-8.47l5.605.738c2.992.393 5.606 2.314 7 4.86 1.963-2.104 4.955-3.288 7.946-2.895l5.606.736z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M87.793 231.21h1.546c1.515 0 2.633-.257 3.355-.77.721-.515 1.082-1.322 1.082-2.424 0-1.09-.368-1.866-1.105-2.328-.737-.461-1.879-.692-3.425-.692h-1.453v6.214zm0 3.964V244H83v-23h6.586c3.072 0 5.344.569 6.818 1.707 1.474 1.138 2.211 2.866 2.211 5.184 0 1.353-.366 2.556-1.098 3.61-.731 1.054-1.767 1.88-3.107 2.478 3.401 5.17 5.617 8.51 6.648 10.021h-5.319l-5.395-8.826h-2.551zm16.11 8.826v-23h4.792v23h-4.792zm15.275-12.176h1.577c1.474 0 2.576-.297 3.308-.89.732-.592 1.098-1.455 1.098-2.587 0-1.143-.307-1.988-.92-2.533-.613-.545-1.574-.818-2.883-.818h-2.18v6.828zm10.822-3.65c0 2.475-.76 4.368-2.28 5.679-1.52 1.31-3.683 1.966-6.486 1.966h-2.056V244h-4.793v-23h7.22c2.742 0 4.826.6 6.254 1.801 1.427 1.201 2.141 2.992 2.141 5.373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M53.5 201l1 5 2 6 .5-6v-6l-3-1.5-3.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M53.5 201l3.5-1v6.5l-2.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E216C",
    d: "M197.467 142.266c-.515 4.576 1.058 10.91 4.207 14.348.399.437.943.405 1.332.153a7.055 7.055 0 0 0 1.71.998c4.846 1.984 10.451-1.752 12.714-5.826 1.684-3.035.627-5.142-1.988-5.583 1.381-3.004-.684-5.482-3.93-4.588-.428-3.098-5.197-3.332-7.22-.788-2.132-2.277-6.37-2.739-6.825 1.286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A7562",
    d: "M220.848 170.074c-5.805-1.57-11.178-3.807-15.494-9.628.142.045-.647-.123-.5-.089 1.596.374 3.16-.04 4.316-1.215 1.062-1.081 2.484-3.738 1.68-5.284-.781-1.497-2.713-2.027-4.226-1.339-.9.411-1.353.585-2.286-.032-.645-.426-1.302-.987-2.08-1.141-.4-.08-.718-.04-.972.076-.535-.18-1.281.045-1.462.762-.67 2.66.618 5.58 2.829 7.157 3.74 6.344 11.446 10.936 18.266 12.487 1.798.41 5.533.278 7.373.166 5.836-.351 15.141-.98 18.952-6.246.38-.525-.429-1.12-.809-.594-3.691 5.101-12.67 4.497-18.335 5.313-.67.097-2.046.135-2.715.222 0 0-1.664-.045-2.005-.06-.755-.034-2.532-.555-2.532-.555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39F85",
    d: "M259.28 131.164l6.163-20.955a7.453 7.453 0 0 0 2.32.285c3.108-.114 5.963-3.002 6.117-6.052 1.184-.741 1.925-2.127 2.323-3.442L290 107.344s-6.355 23.243-15.365 31.096c-9.01 7.854-38.172 29.56-38.172 29.56L231 165.886l28.28-34.722z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39F85",
    d: "M229.038 166.729c-.314.455-1.536 1.913-5.154 3.364-3.25 1.3-10.812 2.056-8.426 4.888 3.732.719 8.028 2.003 8.028 2.003 2.305.213 5.636-1.77 7.472-3.394l5.042-5.667s-.564-3.617-.557-3.79l-1.606-.133a18.209 18.209 0 0 1-4.8 2.729"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39F85",
    d: "M228.604 168.27s-.06.203-.238.531c.486.042.968.112 1.44.199 1.724-.517 3.464-.977 5.194-1.473-.413-1.009-.99-2.422-1.017-2.527l-11.934.873s-.531 1.532 1.892 2.188c2.42.663 4.663.21 4.663.21M277 55.71l4.322 9.29L294 59.259 283.057 44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M263 32.1s2.57 24.147 7.785 26.48c5.214 2.337 11.36-5.84 11.36-5.84L288 38.437 269.422 30 263 32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M254 27.878s4.098 8.24 15.939 4.548c3.343.076 5.14 3.449 6.078 6.447 1.091 3.472 1.458.812 4.214 3.182L285.052 49s11.067-20.906-3.856-27.213C266.266 15.484 254 27.878 254 27.878"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M278.936 37.072c-.973-.36-2.185.665-2.701 2.282-.52 1.622-.146 3.219.829 3.575.975.357 2.184-.668 2.7-2.286.52-1.617.15-3.215-.828-3.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF6874",
    d: "M297.505 57.722C327.2 75.318 315.883 148 315.883 148H270.73s-.521-19.009-1.114-39.089c-.454-15.204-1.888-31.024 2.188-39.671 5.686-11.91 18.327-15.885 25.7-11.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M283 105.114s-6.795 23.39-15.938 31.162C257.92 144.045 231.633 165 231.633 165L223 163.205l28.89-34.583L262.356 95 283 105.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M285.99 108L261 97.843 273.513 70 290 78.579z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M326.637 307s-5.005 4.448-16.415 7.232c-2.512.612-5.222-.204-5.222 3.768h13.847l11.521-1.91V318h6.221s1.729-9.747-1.905-11h-8.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M328.215 299L327 306.68c2.258 1.656 5.222 1.763 7.578.27l.422-.27-.618-7.68h-6.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M316.805 148s4.423 15.222 5.315 52.408c.183 7.522 2.217 14.848 5.471 21.624 12.941 26.91 7.09 78.968 7.09 78.968h-8.938L290 173.104 302.58 148h14.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M277.639 311s-5.01 4.449-16.416 7.235c-2.513.611-5.223-.205-5.223 3.765h13.849l11.518-1.907V322h6.222s1.728-9.75-1.902-11h-8.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M279.215 303L278 310.681a6.677 6.677 0 0 0 7.575.271l.425-.271-.618-7.681h-6.167zM232 165.207l-6.716 9.577c-3.03 3.682-10.823 2.178-15.694-.198a1.043 1.043 0 0 1-.128-1.805c3.5-2.414 12.557-8.585 15.49-9.781l7.048 2.207z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M272 148l4.465 157h9.492s13.364-43.661 10.445-73.786c-.793-8.195.317-16.462 3.603-24.023C314.102 174.783 311.871 148 311.871 148H272z"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "grayscale"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRip);
export default __webpack_public_path__ + "static/media/rip.3c27657d7d5a8279251ad42ec0eb17e1.svg";
export { ForwardRef as ReactComponent };